import React from "react";

const NoResultsSearch = (props) => {
  return (
    <div className="wal-result-none-wrap">
    <div className="wal-result-none-icon">
        <i className="icon-search"></i>
    </div>
    <h1>{props.translate("articles.no_results_found")}</h1>
    <p>{props.translate("articles.empty_description")}</p>
    </div>
  );
};

export default NoResultsSearch;
